import { StateCreator } from "zustand";

export interface GazetteerStore {
    localGazetteerUrl?: string;
    localGazetteerToken?: string;
    nationalGazetteerUrl?: string;
    nationalGazetteerToken?: string;
}

export interface GazetteerSlice {
    gazetteer: GazetteerStore;
    setGazetteer: (state: GazetteerStore) => void;
}

const initialGazetteerState: GazetteerStore = {};

export const createGazetteerSlice: StateCreator<GazetteerSlice, [], [], GazetteerSlice> = (set) => ({
    gazetteer: initialGazetteerState,

    setGazetteer: (state) => set({ gazetteer: state }),
});
